<script>
  export let info
</script>

{#if info}
  <div>
    <span>Jackpot: {info.prize / 1000} sats</span>
    <span>Preço Bilhetes: {info.ticket_price_sats} sats</span>
    <span>Último Sorteio: {info.last_drawing}</span>
  </div>
{/if}

<style>
  div {
    position: absolute;
    display: flex;
    flex: 1 1 auto;
    justify-content: space-around;
    width: 90%;
    max-width: 960px;
    padding: 1rem;
    background: #fff;
    left: 50%;
    border-radius: 3px;
    box-shadow: 0px 12px 23px -10px rgb(0 0 0 / 20%);
    transform: translate3d(-50%, -40%, 0);
  }
</style>
